import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getCitasByEmpleado.php';

export default function getCitasByEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}